import { render, staticRenderFns } from "./BaseScrollableList.vue?vue&type=template&id=0af42e73&scoped=true&"
import script from "./BaseScrollableList.vue?vue&type=script&lang=js&"
export * from "./BaseScrollableList.vue?vue&type=script&lang=js&"
import style0 from "./BaseScrollableList.vue?vue&type=style&index=0&id=0af42e73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af42e73",
  null
  
)

export default component.exports